import { MessageOutlined, PlusOutlined } from "@ant-design/icons";
import { Button, Card, Typography } from "antd";
import { useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useAxiosPrivate } from "../../../hooks/useAxiosPrivate";
import { useChatStore } from "../chat-app-store/chat-store.js";
import { useSessionStore } from "../../../store/session-store.js";
import { NotFound } from "../../../components/error/NotFound/NotFound.jsx";

import "./ChatContext.css";

function ChatContext({ appId }) {
  const axiosPrivate = useAxiosPrivate();
  const { sessionDetails } = useSessionStore();
  const { chatHistory, setChatHistory, setChatTranscript, setCurrentContext } =
    useChatStore();
  const [hasChatFetchError, setHasChatFetchError] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const requestOptions = {
          method: "GET",
          url: `/api/v1/unstract/${sessionDetails?.orgId}/app/chats/${appId}/`,
        };
        const res = await axiosPrivate(requestOptions);
        setChatHistory(res.data);
      } catch (err) {
        setHasChatFetchError(true);
      }
    };
    fetchData();
  }, [sessionDetails]);

  if (hasChatFetchError) {
    return <NotFound />;
  }

  const fetchTranscriptData = async (context) => {
    try {
      const requestOptions = {
        method: "GET",
        url: `/api/v1/unstract/${sessionDetails?.orgId}/chat_history/${context.id}/`,
      };
      const res = await axiosPrivate(requestOptions);
      setChatTranscript(res.data);
    } catch (err) {
      // Todo: Show error alert
    }
  };
  const createNewChat = () => {
    setChatTranscript([]);
    setCurrentContext({});
  };
  const changeContext = (context) => {
    setCurrentContext(context);
    fetchTranscriptData(context);
  };

  return (
    <div>
      <Button onClick={() => createNewChat()} className="add-question-button">
        <PlusOutlined />
      </Button>
      <div className="chat-history-box">
        {chatHistory.map((item, index) => (
          <Card
            key={item.id}
            className="chat-context"
            hoverable
            onClick={() => changeContext(item)}
          >
            <MessageOutlined />
            <Typography.Text className="context-text">
              {item.label}
            </Typography.Text>
            {/* <DeleteOutlined
              className="context-edit-icon"
              onClick={() => deleteChatHistory(item)}
            /> */}
            {/* <EditOutlined
            className="context-edit-icon"
            onClick={() => editChatContext(item)}
          /> */}
          </Card>
        ))}
      </div>
    </div>
  );
}

ChatContext.propTypes = {
  appId: PropTypes.string.isRequired,
};

export { ChatContext };
